import { FilterList, MultiSelectSimpleFilter } from "@dash/filters";
import { SearchBox } from "@dash/search";

import { BlikCheckStatus } from "@megaron/cash-rewards-contracts";

export type BlikChecksFilterValues = {
  status?: BlikCheckStatus[];
  searchTerm?: string;
};

type Props = {
  values: BlikChecksFilterValues;
  onChange: (patch: Partial<BlikChecksFilterValues>) => void;
  className?: string;
};

export const BlikChecksFilters: React.FC<Props> = ({ values, onChange, className }) => {
  const statusOptions: { value: BlikCheckStatus; label: string }[] = [
    { value: "pending", label: "Oczekujący" },
    { value: "outstanding", label: "Do realizacji" },
    { value: "cashed", label: "Zrealizowany" },
    { value: "cancelled", label: "Anulowany" },
    { value: "expired", label: "Wygasły" },
    { value: "blocked", label: "Zablokowany" },
    { value: "bankRejected", label: "Odrzucony przez bank" },
    { value: "pspRejected", label: "Odrzucony przez PSP" },
    { value: "processing", label: "W trakcie" },
  ];

  return (
    <div className={className} css={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", alignItems: "flex-start" }}>
      <FilterList>
        <MultiSelectSimpleFilter
          label="Status"
          options={statusOptions}
          values={values.status ?? []}
          onChange={(v: BlikCheckStatus[]) => onChange({ status: v.length > 0 ? v : undefined })}
        />
      </FilterList>
    </div>
  );
};
